// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-layer-features-counter-badge {
  background-color: #fff;
  position: absolute;
  top: 16px;
  right: 16px;
  border-radius: 15px;
}
wm-layer-features-counter-badge > div {
  display: flex;
  flex-direction: row;
  align-items: center;
}
wm-layer-features-counter-badge > div > div {
  position: relative;
  padding: 4px 12px;
  font-size: 12px;
}
wm-layer-features-counter-badge > div > div span:first-child {
  font-weight: bold;
  margin-right: 4px;
}
wm-layer-features-counter-badge > div > div:not(:first-child)::before {
  position: absolute;
  left: 0;
  content: "";
  width: 1px;
  height: calc(100% - 8px);
  background-color: var(--ion-text-color, #000);
  opacity: 0.31;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/layer-features-counter-badge/layer-features-counter-badge.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;AACF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAEJ;AADI;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;AAGN;AAFM;EACE,iBAAA;EACA,iBAAA;AAIR;AADI;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,UAAA;EACA,wBAAA;EACA,6CAAA;EACA,aAAA;AAGN","sourcesContent":["wm-layer-features-counter-badge{\n  background-color: #fff;\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  border-radius: 15px;\n  >div{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    >div{\n      position: relative;\n      padding: 4px 12px;\n      font-size: 12px;\n      span:first-child{\n        font-weight: bold;\n        margin-right: 4px;\n      }\n    }\n    >div:not(:first-child)::before{\n      position: absolute;\n      left: 0;\n      content: '';\n      width: 1px;\n      height: calc(100% - 8px);\n      background-color: var(--ion-text-color, #000);\n      opacity: 0.31;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
